import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FirmaRemota } from "./view";
interface Props {
    match: match<{ id: string }>;
}
class FirmaRemotaRoute extends React.Component<Props> {
    render() {
        const props = this.props;
        return <FirmaRemota id={this.props.match.params.id} />
    }
}

export class FirmaRemotaIndex extends React.Component<{ match: match<{}> }> {
    render() {
        return (
            <div>
                <Route path={this.props.match.path + "/:id"} component={FirmaRemotaRoute} />
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/firmaremota/index.tsx